import { ListItem, ListItemButton, ListItemText, useTheme } from "@mui/material";
import { useClientPortalNavigate } from "../../../../../hooks/useClientPortalRouter";

import { useClientPortalLocation } from "../../../../../hooks/useClientPortalLocation";
import { type LucideIcon } from "lucide-react";

interface IHeaderListItemProps {
    title: string;
    handleClose?: () => void;
    path?: string;
    handleClick?: () => void;
    icon: LucideIcon;
}

export default function HeaderListItem({ path, handleClose, title, icon: Icon, handleClick }: IHeaderListItemProps) {
    const navigateTo = useClientPortalNavigate();
    const location = useClientPortalLocation();
    const theme = useTheme();
    const navigateToUrl = (url: string) => {
        handleClose?.();
        if (handleClick) {
            handleClick();
        } else {
            navigateTo(url);
        }
    };

    return (
        <ListItem data-test-id={`list_item_${title}`}>
            <ListItemButton
                data-test-id={`button_list_item_${title}`}
                onClick={() => navigateToUrl(path)}
                sx={{ display: "flex", gap: "8px" }}
            >
                <Icon
                    data-test-id={`icon_header_list_item_${title}`}
                    color={location === path ? theme.palette.primary.main : theme.palette.text.secondary}
                    size={20}
                    strokeWidth={2}
                    style={{ minWidth: "36px" }}
                    aria-hidden
                />
                <ListItemText
                    data-test-id={`list_item_text_title_${title}`}
                    sx={{ ...(location === path && { color: theme.palette.primary.main }) }}
                >
                    {title}
                </ListItemText>
            </ListItemButton>
        </ListItem>
    );
}
